import { render, staticRenderFns } from "./ProjectSimulations.vue?vue&type=template&id=77b9c829&scoped=true&"
import script from "./ProjectSimulations.vue?vue&type=script&lang=js&"
export * from "./ProjectSimulations.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSimulations.vue?vue&type=style&index=0&id=77b9c829&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b9c829",
  null
  
)

export default component.exports